import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { DESIGN_SYSTEM } from '../../theme/designSystem';

/**
 * Header unificado para todas las páginas
 * Garantiza consistencia en títulos y subtítulos
 */
export default function PageHeader({ title, subtitle, icon, children }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: DESIGN_SYSTEM.spacing.sectionGap }}>
      <Box display="flex" alignItems="center" gap={2} mb={1}>
        {icon && (
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '1.5rem'
            }}
          >
            {icon}
          </Box>
        )}
        <Box flex={1}>
          <Typography 
            variant="h4" 
            sx={{
              ...DESIGN_SYSTEM.typography.pageTitle,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography 
              variant="body1" 
              sx={DESIGN_SYSTEM.typography.pageSubtitle}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {children && (
          <Box>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );
}
